/**
 * The song key as a chart states it: ChordPro {key: …} or a "Key: …" line.
 * Charts that don't state one import without a key — it is never guessed.
 */
import { parseNote } from '../noteMigration.js';
/**
 * Reads a key as written in a chart: "G", "F#m", "Bb major", "C# minor",
 * "Am (capo 2)". Returns null if it doesn't start with a key.
 */
export const parseKeyText = (text) => {
    const match = text.trim().match(/^([A-Ga-g])([#b♯♭]?)\s*([A-Za-z]*)/);
    if (!match)
        return null;
    const [, letter, accidental, word] = match;
    const lower = word.toLowerCase();
    let mode;
    if (word === 'm' || lower === 'min' || lower === 'minor')
        mode = 'min';
    else if (word === '' || word === 'M' || lower === 'maj' || lower === 'major')
        mode = 'maj';
    else
        return null;
    return { note: parseNote(letter.toUpperCase() + accidental), mode };
};
